var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_56335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 11.001C0.25 5.06488 5.06391 0.250977 11 0.250977C16.9361 0.250977 21.75 5.06488 21.75 11.001C21.75 16.9371 16.9361 21.751 11 21.751C5.06391 21.751 0.25 16.9371 0.25 11.001Z",
    fill: "#FFEFD6",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4707 14.7378L9.54143 15.3449L11.1033 15.7339L12.6652 15.3449L12.7359 14.7378H9.4707Z",
    fill: "#302F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1978 15.1385C11.0111 15.5924 11.9247 16.0933 12.1604 16.1346C13.1506 16.3114 13.8756 16.8006 13.7989 17.001C13.7989 17.001 11.465 16.6651 9.74982 16.3173C9.08381 16.1876 9.56711 14.7849 10.1978 15.1385Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1982 15.1387C9.5676 14.7851 9.00767 14.4668 8.87211 14.4196C8.37702 14.231 7.21003 13.7949 6.95069 14.6613C6.69136 15.5218 7.57545 15.6927 8.2061 15.9344C8.51258 16.0522 9.08429 16.1878 9.74441 16.3234C9.84461 15.9049 9.99196 15.5041 10.1982 15.1387Z",
    fill: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.011 15.1385C11.1977 15.5924 10.2841 16.0933 10.0484 16.1346C9.05818 16.3114 8.33323 16.8006 8.40985 17.001C8.40985 17.001 10.7438 16.6651 12.459 16.3173C13.125 16.1876 12.6417 14.7849 12.011 15.1385Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0137 15.1387C12.6443 14.7851 13.2042 14.4668 13.3398 14.4196C13.8349 14.231 15.0019 13.7949 15.2612 14.6613C15.5206 15.5218 14.6365 15.6927 14.0058 15.9344C13.6993 16.0522 13.1276 16.1878 12.4675 16.3234C12.3673 15.9049 12.22 15.5041 12.0137 15.1387Z",
    fill: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6652 10.7712C12.7772 10.0934 12.2232 8.8616 12.2232 8.8616C11.9579 8.82624 11.6809 8.81445 11.4746 8.81445H10.732C10.5198 8.81445 10.2487 8.82624 9.98348 8.8616C9.98348 8.8616 9.42945 10.0993 9.54143 10.7712C9.64752 11.4019 9.82434 12.3272 9.4707 14.7378H11.1033H12.7359C12.3823 12.3272 12.5591 11.4019 12.6652 10.7712Z",
    fill: "#B3233B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37918 14.1954L6 13.3584L6.17682 13.2523L7.33792 13.6826L8.3281 12.3034C8.53439 11.7612 8.50492 9.35645 9.04127 9.07944C9.42437 8.87904 9.99608 8.85547 9.99608 8.85547C9.99608 8.85547 9.74264 10.1993 9.5894 10.2052C9.43616 10.2111 9.46563 10.6295 9.33007 11.1895C9.27113 11.7199 9.22398 12.1325 9.1061 12.4743L7.37918 14.1954Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55602 13.7356L7.09629 13.6884L7.26721 13.2818L6.99609 13.1403L7.0845 13.0283L7.49118 13.1285L7.55602 13.7356Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5957 13.606L6.84914 13.6355L6.95523 13.2995L7.1792 13.217L7.14973 13.0933L6.83735 13.105L6.5957 13.606Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8357 14.1954L16.2148 13.3584L16.038 13.2523L14.8769 13.6826L13.8867 12.3034C13.6804 11.7612 13.7099 9.35645 13.1736 9.07944C12.7905 8.87904 12.2188 8.85547 12.2188 8.85547C12.2188 8.85547 12.4722 10.1993 12.6254 10.2052C12.7787 10.2111 12.7492 10.6295 12.8848 11.1895C12.9437 11.7199 12.9909 12.1325 13.1087 12.4743L14.8357 14.1954Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6504 13.7356L15.1101 13.6884L14.9451 13.2818L15.2103 13.1403L15.1219 13.0283L14.7152 13.1285L14.6504 13.7356Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6206 13.606L15.3613 13.6355L15.2611 13.2995L15.0312 13.217L15.0666 13.0933L15.3731 13.105L15.6206 13.606Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 8.13672H10.6035C10.7568 8.60823 10.6153 8.82041 10.6153 8.82041C10.6153 8.82041 10.6448 9.1269 11.1045 9.1269C11.5583 9.1269 11.5878 8.82041 11.5878 8.82041C11.5878 8.82041 11.4463 8.60234 11.5996 8.13672Z",
    fill: "#E2A379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1252 6.76342C12.1252 5.57874 11.6655 5.30762 11.1056 5.30762C10.5398 5.30762 10.0859 5.57874 10.0859 6.76342C10.0859 7.1642 10.1567 7.47658 10.2628 7.71823C10.4985 8.24869 10.9052 8.43729 11.1056 8.43729C11.306 8.43729 11.7127 8.24869 11.9484 7.71823C12.0545 7.47658 12.1252 7.1642 12.1252 6.76342Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.394 7.95406C11.394 7.95406 11.2643 8.01889 11.1052 8.01889C10.9461 8.01889 10.8164 7.95406 10.8164 7.95406C10.8164 7.93638 10.9107 7.83029 10.9696 7.82439C11.005 7.8185 11.1052 7.85386 11.1052 7.85386C11.1052 7.85386 11.1995 7.8185 11.2408 7.82439C11.2997 7.83029 11.394 7.95406 11.394 7.95406Z",
    fill: "#D6876B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.394 7.95389C11.394 7.95389 11.2643 8.07177 11.1052 8.07177C10.9461 8.07177 10.8164 7.95389 10.8164 7.95389C10.8164 7.95389 10.8459 7.91853 11.0168 7.90674C11.0463 7.90674 11.0816 7.93031 11.1052 7.93031C11.1288 7.93031 11.1583 7.90674 11.1818 7.90674C11.3586 7.91853 11.394 7.95389 11.394 7.95389Z",
    fill: "#CC785E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1047 5.73182C11.4009 5.73182 11.6411 5.56822 11.6411 5.3664C11.6411 5.16458 11.4009 5.00098 11.1047 5.00098C10.8085 5.00098 10.5684 5.16458 10.5684 5.3664C10.5684 5.56822 10.8085 5.73182 11.1047 5.73182Z",
    fill: "#4C230C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1648 6.81643C12.1648 5.63175 11.8406 5.31348 11.1039 5.31348C10.3671 5.31348 10.043 5.63764 10.043 6.81643C10.043 6.81643 11.6166 6.47458 11.6166 6.04432C11.6166 6.47458 12.1648 6.81643 12.1648 6.81643Z",
    fill: "#602F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98345 7.18144C10.0365 7.50561 10.1072 7.5174 10.2074 7.49972L10.1013 6.79834C10.0011 6.81602 9.92451 6.85728 9.98345 7.18144Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1061 6.79834L12 7.49972C12.1002 7.5174 12.165 7.49972 12.224 7.18144C12.2829 6.85728 12.2063 6.81602 12.1061 6.79834Z",
    fill: "#F4B382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1608 6.8632C10.155 6.82784 10.155 6.79837 10.155 6.7689C10.155 6.73354 10.1608 6.70996 10.1608 6.70996L10.043 6.75711C10.043 6.77479 10.043 6.79248 10.043 6.81016C10.043 6.81016 10.0548 6.80426 10.0783 6.79837C10.0783 6.79837 10.0783 6.79837 10.0724 6.79837C10.0901 6.82784 10.1078 6.8691 10.1314 6.93393C10.1314 6.93982 10.1785 6.97519 10.1608 6.8632Z",
    fill: "#602F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.047 6.77479C12.047 6.79837 12.047 6.83373 12.0411 6.8632C12.0234 6.96929 12.0705 6.93393 12.0705 6.93393C12.0882 6.8691 12.1118 6.82784 12.1295 6.79837C12.1531 6.80426 12.1648 6.81016 12.1648 6.81016C12.1648 6.79248 12.1648 6.77479 12.1648 6.75711L12.047 6.70996C12.0411 6.71585 12.047 6.73943 12.047 6.77479Z",
    fill: "#602F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_56335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerYoga);
export default __webpack_public_path__ + "static/media/consumer_yoga.769b718edcba27eac7726cdd72dd41bd.svg";
export { ForwardRef as ReactComponent };